import { Component, inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';
import { AspectRatio, CodifiedUse, MediaFormat, Shot, ShotType } from '../../../models/new/shot';
import { GraphQLService } from 'src/app/services/graph-ql.service';
import { TemplatesQueries } from 'src/app/shared/types/get-query/templates-queries.enum';
import { TemplateMapper } from '../../../services/template-mapper';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { SnackbarType } from 'src/app/shared/components/snackbar/snackbar.component';
import { Selectable } from 'src/app/shared/types/selectable.type';

@Component({
	selector: 'bt-add-shot-modal',
	standalone: false,
	templateUrl: './add-shot-modal.component.html',
	styleUrl: './add-shot-modal.component.scss'
})
export class AddShotModalComponent implements OnInit {
	readonly #dialogRef = inject(MatDialogRef<AddShotModalComponent>);

	readonly #data = inject(MAT_DIALOG_DATA);
	shot: Shot = new Shot();
	shotTypes: ShotType[] = [];
	mediaFormats: MediaFormat[] = [];
	aspectRatios: Selectable<AspectRatio>[] = [];
	codifiedUses: CodifiedUse[] = [];

	constructor(
		private graphQLService: GraphQLService,
		private appService: AppService,
		private templateMapper: TemplateMapper,
		private utilitiesService: UtilitiesService
	) {}

	ngOnInit() {
		this.prepareSelect();
	}

	prepareSelect() {
		this.graphQLService.getData<MediaFormat>(TemplatesQueries.GET_MEDIA_FORMATS).subscribe({
			next: (res: any) => {
				this.mediaFormats = res.data.mediaFormats.nodes.map((mf: any) => this.templateMapper.toMediaFormat(mf));
			},
			error: (err) => {
				this.utilitiesService.showSnackbar('Error fetching media formats', SnackbarType.Error);
			}
		});

		this.graphQLService.getData<AspectRatio>(TemplatesQueries.GET_ASPECT_RATIOS).subscribe({
			next: (res: any) => {
				this.aspectRatios = res.data.aspectRatios.nodes.map((ar: any) => ({ ...this.templateMapper.toAspectRatio(ar), selected: false }));
				this.aspectRatios[0].selected = true;
			},
			error: (err) => {
				this.utilitiesService.showSnackbar('Error fetching aspect ratios', SnackbarType.Error);
			}
		});

		this.graphQLService.getData<ShotType>(TemplatesQueries.GET_SHOT_TYPES).subscribe({
			next: (res: any) => {
				this.shotTypes = res.data.shotTypes.nodes.map((st: any) => this.templateMapper.toShotType(st));
			},
			error: (err) => {
				this.utilitiesService.showSnackbar('Error fetching shot types', SnackbarType.Error);
			}
		});

		this.graphQLService.getData<CodifiedUse>(TemplatesQueries.GET_CODIFIED_USES).subscribe({
			next: (res: any) => {
				this.codifiedUses = res.data.codifiedUses.nodes.map((cu: any) => this.templateMapper.toCodifiedUse(cu));
			},
			error: (err) => {
				this.utilitiesService.showSnackbar('Error fetching codified uses', SnackbarType.Error);
			}
		});
	}

	selectAspectRatio(aspectRatio: Selectable<AspectRatio>) {
		this.aspectRatios.forEach((ar) => (ar.selected = ar.id === aspectRatio.id ? !ar.selected : false));
	}

	close() {
		this.#dialogRef.close(null);
	}

	validateShot(): boolean {
		return this.shot.codifiedUse && this.shot.mediaFormat && this.shot.shotType && this.aspectRatios.find((ar) => ar.selected) ? true : false;
	}

	apply() {
		this.shot.aspectRatio = this.aspectRatios.find((ar) => ar.selected) || undefined;
		console.log(this.shot.aspectRatio);
		this.shot.mandatory = this.shot.aspectRatio?.id == 1 ? true : false;

		this.#dialogRef.close(this.shot);
	}
}
